<template>
<span>
    <slot>
        {{ value }}
    </slot>
</span>
</template>
<script>
import { filterCards, applyFilters } from '@/utils/filter-cards';
import { safeParse, jsonCopy } from '@/utils/json';
import { mapState } from 'vuex';

export default {
    props: {
        apply: {
            default: '{}',
            type: String,
            _descr: 'Filter rules to apply',
        },
        applyCurrent: {
            default: 'false',
            type: String,
            _descr: 'Extend currently applied rules',
        },
    },
    data () {
        return {
            purpose: 'for-value-node', // ancor for value tag,
            questionId: undefined,
            stateId: undefined,
        };
    },
    mounted () {
        this.questionId = this.$el.closest('[data-question-id]').getAttribute('data-question-id');
        this.stateId = this.$el.closest('[data-step-id]').getAttribute('data-step-id');
    },
    computed: {
        ...mapState('flow', {
            flowHistory: 'history',
        }),
        eApply () {
            return safeParse(this.apply);
        },
        eApplyCurrent () {
            return safeParse(this.applyCurrent);
        },
        question () {
            if (!this.questionId || !this.stateId) {
                return;
            }

            let step = this.flowHistory.find(step => step.stateId === this.stateId);
            if (!step) {
                return;
            }
            return step.questions.find(question => question.id === this.questionId);
        },
        value () { // used in 'value', and in 'when' childrens nodes
            if (this.question) {
                return filterCards(this.question.data.filters, this.question.data.slotCards, applyFilters(jsonCopy(this.question.data.effective.filters || {}), {}, this.eApplyCurrent, this.eApply)).length;
            }
            return null;
        },
    },
};
</script>
